module.exports = __webpack_public_path__ + "static/portrait-about-9fa08481db6ade8e286f2d86a6305a00.png";